<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <div class="flex -mx-2 text-4xl font-bold">
        <router-link to="/af/maler" class="px-4 text-red-500"><div class="border-b-2 border-red-500">Maler</div></router-link>
        <router-link to="/af/meldingslogg" class="px-4 text-red-400">Meldingslogg</router-link>
        <router-link to="/af/smslogg" class="px-4 text-red-400">SMS logg</router-link>
      </div>
      <!-- <div class="flex itens-center">
        <router-link class="ml-4 btn btn-primary" to="maler/opprett">Ny mal</router-link>
      </div> -->
    </div>
    <panel>
      <data-table
        :headers="headers"
        :items="emailTemplates"
        @click="onClick">
      </data-table>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'template-list',
  data () {
    return {
      headers: [
        { text: 'Navn', align: 'left', value: 'name' },
        { text: 'Mottakere', align: 'left', value: 'to' },
      ],
      emailTemplates: []
    }
  },
  methods: {
    onClick (template) {
      this.$router.push('/af/maler/' + template.emailTemplateId)
    }
  },
  async created () {
    this.emailTemplates = await api.af.getEmailTemplates()
  }

}
</script>